import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

if (!url || !key) {
  // Shown in the browser console if Netlify env vars are missing
  console.error("Missing VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY");
}

export const supabase = createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true },
});

export type DeviceState = {
  device_id: string;
  lat: number | null;
  lng: number | null;
  speed_kn: number | null;
  course: number | null;
  altitude: number | null;
  valid: boolean | null;
  ignition: boolean | null;
  battery: number | null;
  attrs: Record<string, unknown>;
  fix_at: string | null;
  seen_at: string;
  quality?: "good" | "low" | "no_fix" | "suspect";
  held_since?: string | null;
  report_s?: number | null;   // V3.12.0: learned normal gap between reports (s), kept by trigger (migration 0021)
  /** V3.9.2: first stopped fix after moving (null while moving or not known) */
  stopped_since?: string | null;
  raw_lat?: number | null;
  raw_lng?: number | null;
  raw_at?: string | null;
};

export type Device = {
  id: string;
  org_id?: string;
  name: string;
  model: string | null;
  unique_id: string;
  status: string;
  icon: string | null;
  group_id: string | null;
  state: DeviceState | null;
  /** V3.3.0 display settings (null colour = automatic) */
  icon_color?: string | null;
  tail_on?: boolean;
  tail_minutes?: number;
  tail_seconds?: number | null;
  tail_color?: string | null;
};
